import { Input } from 'antd';
import React, { forwardRef, ReactElement } from 'react';
import ReactInputMask from 'react-input-mask';
import PropTypes from 'prop-types';

const InputMask = forwardRef((props: any, ref: any): ReactElement => {
  const { allowClear, disabled } = props;
  return (
    <ReactInputMask {...props}>
      {(inputProps: any): ReactElement => (
        <Input
          {...inputProps}
          allowClear={allowClear}
          ref={ref}
          disabled={disabled ? disabled : null}
        />
      )}
    </ReactInputMask>
  );
});

InputMask.propTypes = {
  mask: PropTypes.string,
  maskChar: PropTypes.string,
  formatChars: PropTypes.object,
  alwaysShowMask: PropTypes.bool,
  inputRef: PropTypes.func,
};

export default InputMask;
